module.exports = "/_next/static/images/46a6db79f4c851d3dc5b19ef8d71a79c-roxinho-card-with-phone-lg@3x.jpg";